import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';

@Injectable({
    providedIn: 'root'
})

export class MBService {

    constructor() { }

    OcurrioError(msg: string): void {
        Swal.fire({
            title: 'Error !!!',
            text: msg,
            icon: 'error',
            confirmButtonText: 'Aceptar'
        });
    }

    Notificar(msg: string): void {
        Swal.fire({
            title: '',
            text: msg,
            icon: 'info',
            confirmButtonText: 'Aceptar'
        });
    }

    Ok(msg: string): void {
        Swal.fire({
            title: msg,
            showClass: {
                popup: 'animate__animated animate__fadeInDown'
            },
            hideClass: {
                popup: 'animate__animated animate__fadeOutUp'
            }
        });
    }

  confirmaMed(): string {
    let Contest: string =""
      Swal.fire({
        title: 'Está Usted Seguro?',
        text: "¡No podrás revertir esto!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sí, Eliminarlo!'
      }).then((result) => {
        if (result.isConfirmed) {
          Contest = "Ok";
        }
      })
      console.log(Contest);
      return Contest;
    }

}
